import { GridNode, GridState } from '../types';

/**
 * Order the "source" nodes (generators + batteries) for the load-curve editor's
 * stacked-area chart and its legend.
 *
 * Generators are sorted by marginal cost ascending, so the cheapest source ends
 * up at the bottom of the stack (base load) and the most expensive "peaker"
 * plants sit at the top, served only when demand is high. Batteries are placed
 * above the generators since they discharge to shave the peak.
 *
 * Both the stacked-area renderer and the legend consume this single ordering so
 * their colors (assigned by index) stay in sync.
 */
export function getOrderedSourceNodes(gridState: GridState): GridNode[] {
  const generators = gridState.nodes.filter((node) => node.type === 'generator');
  const batteries = gridState.nodes.filter((node) => node.type === 'battery');

  const byCostAscending = [...generators].sort(
    (a, b) => (a.costPerMWh ?? 0) - (b.costPerMWh ?? 0)
  );

  return [...byCostAscending, ...batteries];
}
